import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-716da9cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-internal-user" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3 pb-3" }, "Deleteing....", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "card"
}
const _hoisted_6 = { class: "card-header d-flex justify-content-between align-items-center p-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Delete Variable", -1))
const _hoisted_8 = {
  key: 0,
  class: "card-body p-0"
}
const _hoisted_9 = { class: "mt-4 mb-5" }
const _hoisted_10 = {
  key: 1,
  class: "card-body p-0"
}
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "card-footer d-flex p-0" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.creating)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.creating)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_feather_icon, {
              type: "x",
              class: "cursor-pointer",
              stroke: "rgba(31, 50, 69, 0.5)",
              size: "20",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
            })
          ]),
          (_ctx.errMsg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.errMsg) + " ", 1),
                  _createElementVNode("div", {
                    class: "btn btn-light float-end mt-3",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["stop"]))
                  }, "Rest")
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.errMsg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, "Are you sure you want to delete the task \"" + _toDisplayString(_ctx.name) + "\"?", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "me-1 btn btn-dark",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["stop"])),
              disabled: !_ctx.canStore
            }, "Delete", 8, _hoisted_13),
            _createElementVNode("button", {
              class: "ms-1 btn btn-outline-dark",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel')))
            }, "Cancel")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}